import * as React from 'react';
import useSWR, { useSWRConfig } from "swr";
import { HomeWidget, 
  //HomeWidgetError, HomeWidgetVacio, 
  api, PortalContext } from '@portal/arq-portal-core';
import { TextField, Button } from '@material-ui/core';
													 
import Flippy, { FrontSide, BackSide } from 'react-flippy';
import { Elemento } from './Elemento';
import { DetalleElemento } from './DetalleElemento';

export function Muro(props: any): JSX.Element {
  const [isLoading,setIsLoading] = React.useState(true);
  const [agentesCom] = React.useState(props.agentesCom);
  const [entryValue, setEntryValue] = React.useState('');
  const [selectedItem,setSelectedItem] = React.useState(null);
  const  { ciaGestiona } = React.useContext(PortalContext);

  var urlParams = new URLSearchParams(window.location.search);
  var ciaUrl = urlParams.get('cia');
  let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;
  
  const { mutate } = useSWRConfig();
  const config = { dedupingInterval: 60000 };
  let ref: any; 

  const isDateOverOneYearOld = (dateString: string) => {
    var givenDate = new Date(dateString);
    var currentDate = new Date();
    var oneYearLater = new Date(givenDate.getFullYear() + 1, givenDate.getMonth(), givenDate.getDate());
  
    return oneYearLater <= currentDate;
  }

  const getWallElements = (page:string, pagesize:string,communityId:string,isMockup:boolean,mockupStateElementComment:string) =>  useSWR(['getwallelements'], 
        ()=> {
          // console.log("get wall elem");
          return api.post('/be/piupointgetwallelements/',{"Entrada":{"cia": cia,"page":page,"pageSize":pagesize,"communityId":communityId,"isMockup":isMockup,"mockupStateElementComment":mockupStateElementComment}})
            .then((x:any)=> {  if(isLoading) {setIsLoading(false)}; return x;})
        }, config);

  let { data, error } = getWallElements('1','10',agentesCom.CommunityId, false, '');
  let datos = []; 			
  try {
    datos = data?.Salida?.response?JSON.parse(data.Salida.response):[];
    if(datos[0] && isDateOverOneYearOld(datos[0].CreationDate)) {
      datos = [];
    }
  }	catch {
    console.log(error);
  }			

  const publishEntry = () => {
    let jsonNew = {
      Title: "",
      Body: entryValue,
      AllowComments: true,
      Type: "",
      PreviewThumbnailUrl: "",
      PreviewTitle: "",
      PreviewBody: "",
      PreviewUrl: "",
      PreviewUrlOriginal: "",
      Communities: [agentesCom.CommunityId] 
    };

    api.post('/be/piupointcreatewallelement/', {"Entrada": {"json": JSON.stringify(jsonNew),"cia": cia}}).then(() => {
      mutate(["getwallelements"]);
      setEntryValue('');
    });
  };

  const handleTextChange = (event: any) => {
    setEntryValue(event.target.value);
  };

  const flipcard = () => { ref.toggle(); } 
 
  return (<React.Fragment> 
    <Flippy
    flipOnHover={false} 
    flipOnClick={false} 
    flipDirection="horizontal" 
    ref={(r:any) => ref = r}
  >
    <FrontSide className="frontSide">
      <HomeWidget titulo="Foro" vermas="/foro" isLoading={isLoading}>
        {agentesCom && agentesCom.Permissions.CanCreate &&
          <div className="contentReplyForum">
            <TextField {...props} id="entrada" placeholder="Escribe un comentario..." variant="outlined" size="small"
              className="entry inputReplyForum"
              value={entryValue}
              onChange={handleTextChange}
              multiline
              inputProps={{style: {fontSize: 12}}} 
              InputLabelProps={{style: {fontSize: 12}}} 
            />
            <Button disabled={entryValue === ''} variant="text" onClick={publishEntry} className={`publicarElemento ${entryValue === '' ? `disabled` : ``}`}>
              Publicar
            </Button>
          </div>   
        }   

        <div className="widget-content">
          <div className="elementsWrapper">																			
            {datos.length > 0 
            ? datos.map((el: any, index: any) => {
              return (<div onClick={ () => {
                 ref.toggle(); 
                 setSelectedItem(el.WallElementId); 
                 }}>
                  <Elemento key={index} elemento={el} elementos={datos.length}/></div>) 
              })
            :
              <div className="noEntradas">No hay entradas para mostrar</div>
            }
          </div>
        </div>						
		  
      </HomeWidget>
    </FrontSide>

    <BackSide className="backSide">
      <div>
        <div className="goBack" onClick={() => { ref.toggle(); setSelectedItem(null); mutate(["getwallelements"]);}}>
          <i className="icon-flecha-izq"></i>
          <a  className="volver">Volver a foro </a>
        </div>
        {datos?.find((elem: any) => (elem.WallElementId == selectedItem)) && 
          <DetalleElemento selectedcom={agentesCom.CommunityId}  elemento={datos?.find((elem: any) => (elem.WallElementId == selectedItem))} 
            doflip={()=>flipcard()}/>}
      </div>
    </BackSide>
  </Flippy>
  {/*!error && (!datos || datos.length == 0 )&& <div className="widget-content"><HomeWidgetVacio mensaje="No hay entradas en el muro"></HomeWidgetVacio></div>}
  {error && error.message && !datos && <div className="widget-content"><HomeWidgetError error={error.message}></HomeWidgetError></div>}
        {error && !error.message && !datos && <div className="widget-content"><HomeWidgetError error="Datos no disponibles en estos momentos"></HomeWidgetError></div>*/}
  </React.Fragment>
  )
}